import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import linkUtils from 'src/utils/linkUtils';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import Card from 'src/components/card';

const CommunityHomeSupportUs = ({ widget }) => {
  if (!widget.body && !widget.buttonText && !widget.url) {
    return null;
  }

  return (
    <Card
      title={widget.title || i18n.t('Support Us')}
    >
      <div>{widget.body}</div>
      <div>
        <a
          className="btn btn-secondary community__widget__actions"
          href={linkUtils.prepLink(widget.url)}
          target="_blank"
          onClick={() => {
            trackFootfallEvent(footfallEventTypes.CLICKED, {
              clickType: 'community-support-us',
              clickMetadata: { section: 'community-side-bar' },
            });
          }}
        >
          {widget.buttonText}
        </a>
      </div>
    </Card>
  );
};

CommunityHomeSupportUs.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default CommunityHomeSupportUs;
